// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'obje... Remove this comment to see the full error message
import ObjectBuilderClient from 'object-builder-ui-client';
import { CONTACT_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CONVERSATIONS } from '../constants/AppSource';
import { getCanonicalVid } from 'conversations-inbox-lib/contacts/public/operators';
import { isKnownContact } from '../../contacts/operators/isKnownContact';
import { useTicketCreatorProperties } from '../hooks/useTicketCreatorProperties';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketCreatorPrompt = ({
  contact,
  onClose,
  threadId
}) => {
  const appInfo = useMemo(() => isKnownContact(contact) ? {
    defaultAssociation: {
      objectId: `${getCanonicalVid(contact)}`,
      objectTypeId: CONTACT_TYPE_ID
    }
  } : undefined, [contact]);
  const {
    propertiesLoading,
    ticketCreatorProperties
  } = useTicketCreatorProperties({
    contact,
    threadId
  });
  return useMemo(() => /*#__PURE__*/_jsx(ObjectBuilderClient, {
    appName: CONVERSATIONS,
    appInfo: appInfo,
    defaultProperties: ticketCreatorProperties,
    objectTypeId: TICKET_TYPE_ID,
    onClose: onClose,
    shouldDefaultOwnerId: false,
    shouldRenderCreateAndAddButton: false,
    show: !propertiesLoading
  }), [appInfo, ticketCreatorProperties, onClose, propertiesLoading]);
};
TicketCreatorPrompt.displayName = 'TicketCreatorPrompt';
export default TicketCreatorPrompt;